import type { PeopleRoster, PersonId, TeamMember } from "@don/wire";

import { firstName } from "./team.js";

/**
 * Deactivate's rules, as arithmetic (epic 26-10-02-knowledge-v0, issue 217; ux-spec decision
 * 18, design-spec §5 `deactivate-confirm`, §6, §11 C8 and D4). `deactivate.test.ts` asserts
 * each.
 */

/**
 * The confirm's words (design-spec §6 "Deactivate"; §11 C8: the way out is Cancel, and the body
 * says Reactivate undoes it, owner 2026-10-05), and
 * Deactivate's word while the request is out (as Add's Adding…, §11 D2; the design draws no busy
 * confirm, 217-ux P1-1).
 */
export function deactivateCopy(member: TeamMember): {
  title: string;
  body: string;
  confirm: string;
  busy: string;
  cancel: string;
} {
  return {
    title: `Deactivate ${member.display_name}?`,
    body:
      `${firstName(member)} can no longer sign in to the recorder or share new sessions. ` +
      "Sessions already shared stay in your library. You can reactivate users at any time.",
    confirm: "Deactivate",
    busy: "Deactivating…",
    cancel: "Cancel",
  };
}

/** The page Notice when a deactivate fails (design-spec §6 "Page-level failures", §11 D4). */
export function deactivateFailedCopy(member: TeamMember): string {
  return `Couldn't deactivate ${firstName(member)}. Nothing was changed.`;
}

/**
 * The roster once the server has deactivated one person (it answers 204 with no row): their
 * status is Deactivated, and what the server just revoked and voided is gone from the row, no
 * live computer and no live code (`registry::db::deactivate_person`). `deactivated_at_ms` is
 * the Console's clock, which nothing on the table reads. `orderRoster` then moves the row to
 * the deactivated group; shared sessions and their count are untouched (story 27).
 */
export function withDeactivated(roster: PeopleRoster, personId: PersonId, nowMs: number): PeopleRoster {
  return {
    people: roster.people.map((m) =>
      m.person_id === personId
        ? { ...m, status: "deactivated", deactivated_at_ms: nowMs, has_live_device: false, live_code: null }
        : m,
    ),
  };
}
